import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import FillingCard from '../components/Card';
import { mountCardAttributes } from '../utils';
import { changeRemovePeerNotificationAttrs } from '../../../store/RemovePeerNotifications';

import { StoreState } from '../../../store/types';
import { ILoadingContainerCardInfo } from '../types';

export default (cardInfo: ILoadingContainerCardInfo) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const state: StoreState = useSelector((reduxState: StoreState) => reduxState);

  const {
    notification,
    notificationAttrs,
  } = state.removePeerNotificationsState;
  const { title, canShow, running, attributes, notLoadingWidth } = cardInfo;

  const changeNotification = (params: Record<string, any>) => {
    dispatch(changeRemovePeerNotificationAttrs(params));
  };

  const newCardInfo = {
    canShow,
    running,
    notLoadingWidth,
    notificationAttrs,
    changeNotification,
    loadingInfo: notification,
    attributes: mountCardAttributes(attributes || {}, t),
    loadingStarted: Object.keys(notification).length > 0,
  };

  return <FillingCard cardInfo={{ ...newCardInfo, title }} />;
};
